import { Control, FieldErrors, Controller } from "react-hook-form";
import { MultiSelectAutocomplete } from "@/components/MultiSelectAutocomplete";
import { CustomSelect } from "@/components";
import { UserV2FormValues } from "./UserFormV2";
import { useTagsV2 } from "@/hooks/useTagsV2";
import { TAG_TYPE_NAME } from "@/types/tagsV2";

interface MarketCanvasFormPartProps {
  control: Control<UserV2FormValues>;
  errors: FieldErrors<UserV2FormValues>;
  index: number;
  currentCbsaTags: number[];
  currentConfidentialityLevel: number;
  handleCbsaTagsChange: (selectedCbsaTags: number[]) => void;
  handleConfidentialityLevelChange: (confidentialityLevel: number) => void;
}

export const MarketCanvasFormPart = ({
  control,
  errors,
  index,
  currentCbsaTags,
  currentConfidentialityLevel,
  handleCbsaTagsChange,
  handleConfidentialityLevelChange,
}: MarketCanvasFormPartProps) => {
  const { tagOptions: cbsaOptions, loadingTags: loadingCbsaTags } = useTagsV2(
    TAG_TYPE_NAME.CBSA
  );
  const {
    tagOptions: confidentialityLevelOptions,
    loadingTags: loadingConfidentialityLevelTags,
  } = useTagsV2(TAG_TYPE_NAME.CONFIDENTIALITY_LEVEL);

  return (
    <>
      <Controller
        name={`roles.${index}.cbsaTags` as const}
        control={control}
        render={() => (
          <MultiSelectAutocomplete
            options={cbsaOptions}
            selected={currentCbsaTags}
            setSelected={handleCbsaTagsChange}
            label="Select Regions*"
            placeholder="Select From List"
            maxHeight={300}
            loading={loadingCbsaTags}
          />
        )}
      />
      <CustomSelect
        name={`roles.${index}.confidentiality`}
        label="Confidentiality Level*"
        placeholder="Select Confidentiality Level"
        options={confidentialityLevelOptions}
        value={currentConfidentialityLevel}
        onChange={handleConfidentialityLevelChange}
        error={!!errors.roles?.[index]?.confidentialityLevel}
        helperText={errors.roles?.[index]?.confidentialityLevel?.message}
        loading={loadingConfidentialityLevelTags}
      />
    </>
  );
};
